export interface IHiddenMarketState {
    hasPlacedFirstBet: boolean;
}

export const defaultHiddenMarketState: IHiddenMarketState = {
    hasPlacedFirstBet: false,
};
